<template>
    <div>
        <DeleteItemModal ref="deleteModal"></DeleteItemModal>
        <RestoreItemModal ref="restoreModal"></RestoreItemModal>
        <AggridList ref="aggridlist"
                    :componentGridOptions="gridOptions"
                    :excelColumns='["id", "surname", "name", "lastname", "passport_seria", "passport_number", "company.name", "is_blocked"]'
                    :service="service"
                    :deleted_filter="can('deleted-driver-read')"
        >
            <template v-slot:buttons>
                <router-link
                    v-if="can('create-driver')"
                    :to="{name: 'driver-create'}" class="btn btn-sm btn-primary"><i
                    class="fas fa-plus-square"></i>
                    <span class="d-none d-sm-inline ml-1">
                        {{ trans("Create") }}
                    </span>
                </router-link>
            </template>
        </AggridList>
    </div>
</template>

<script>

import DriverService from "../../services/DriverService";
import FloatingYesNoFilter from "../../aggrid/filters/FloatingYesNoFilter";
import IdCellRenderer from "../../aggrid/cells/IdCellRenderer";
import IdCellParams from "../../aggrid/cells/IdCellParams";
import CRUDCellRenderer from "../../aggrid/cells/CRUDCellRenderer";
import CRUDCellParams from "../../aggrid/cells/CRUDCellParams";

export default {
    data() {
        return {
            service: DriverService,
            gridOptions: {
                columnDefs: [
                    {
                        ...IdCellParams, cellRendererParams: {
                            getRoute(id) {
                                return {
                                    name: "driver-detail",
                                    params: {id}
                                };
                            }
                        }
                    },
                    {
                        headerName: this.trans("driver.Surname"), field: "surname", width: 150,
                        sort: "asc",
                        floatingFilter: true,
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        headerName: this.trans("driver.Name"), field: "name", width: 150,
                        floatingFilter: true,
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        headerName: this.trans("driver.Lastname"), field: "lastname", width: 150,
                        floatingFilter: true,
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        headerName: this.trans("driver.Passport series"), field: "passport_seria", width: 150,
                        floatingFilter: true,
                    },
                    {
                        headerName: this.trans("driver.Passport number"), field: "passport_number", width: 150,
                        floatingFilter: true,
                    },
                    {
                        headerName: this.trans("Company"), field: "company.name", width: 220,
                        floatingFilter: true,
                        suppressMenu: true,
                        floatingFilterComponentParams: {
                            suppressFilterButton: true,
                        },
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.company.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        headerName: this.trans("driver.Is blocked"), field: "is_blocked", width: 140,
                        filter: "agNumberColumnFilter",
                        suppressMenu: true,
                        floatingFilter: true,
                        floatingFilterComponent: "FloatingYesNoFilter",
                        floatingFilterComponentParams: {
                            suppressFilterButton: true
                        },
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            return prop.value ? '<i class="fas fa-check"></i>' : null;
                        }
                    },
                    {
                        ...CRUDCellParams,
                        cellRendererParams: {
                            canRead: (params) => {
                                return this.can("read-driver", params.data);
                            },
                            readCb: (id) => {
                                this.$router.push({name: "driver-details", params: {id}});
                            },
                            canEdit: (params) => {
                                return this.can("update-driver", params.data);
                            },
                            editCb: (id) => {
                                this.$router.push({name: "driver-edit", params: {id}});
                            },
                            canDelete: (params) => {
                                return this.can("delete-driver", params.data);
                            },
                            canRestore: (params) => {
                                return this.can("restore-driver", params.data);
                            },
                            deleteCb: (id) => {
                                this.$refs.deleteModal.show(async () => {
                                    try {
                                        await DriverService.remove(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("driver.Driver deleted"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Delete Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            },
                            restoreCb: (id) => {
                                this.$refs.restoreModal.show(async () => {
                                    try {
                                        await DriverService.restore(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("driver.Driver restored"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Restore Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            }
                        }
                    },
                ],
                frameworkComponents: {
                    FloatingYesNoFilter, IdCellRenderer, CRUDCellRenderer
                }
            }
        }
    }
}
</script>
